import { Box, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const DisableFutureDate = ({
  title,
  name,
  handleChange,
  placeholder,
  value,
  errors,
}) => {
  const today = dayjs();
  const formattedValue = value ? dayjs(value) : null;

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
        {title}
      </Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          sx={{ width: "100%" }}
          name={name}
          value={formattedValue}
          onChange={(newValue) => {
            handleChange({
              name,
              value: newValue ? newValue.format("YYYY-MM-DD") : null,
            });
          }}
          format="DD/MM/YYYY"
          minDate={today}
          slotProps={{
            textField: {
              fullWidth: true,
              size: "small",
              error: Boolean(errors && errors !== ""),
              inputProps: {
                placeholder: placeholder || "DD/MM/YYYY",
              },
            },
          }}
        />
      </LocalizationProvider>
      {errors && (
        <Typography variant="body2" color="#D34040">
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default DisableFutureDate;
